var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('domain-details',{attrs:{"user-role":_vm.user_role,"param-id":_vm.getUrlParameter('domain_id'),"param-name":_vm.getUrlParameter('domain_name')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }